import React from "react";
import Card from "../UI/Card";
import MediumHeading from "../UI/MediumHeading";
import "./style.css";

const AboutMe = () => {
  return (
    /*  <div>
      <video autoPlay loop muted className="videoo">
        <source src={bgVideo} type="video/mp4" />
      </video>
       <div className="player-wrapper">
        <ReactPlayer
          className="react-player"
          width="100%"
          height="100%"
          url={bgVideo}
          playing
          muted
        />
      </div> */
    <div className="container scaleUp">
      <Card className="cardAM">
        <MediumHeading text="About Me" />
        <br />
        <br />
        <p className="font-22" style={{ color: "#333333" }}>
        A Software engineer with excellent problem solving skills and able to quickly learn and adapt to new technologies. I have 2 years of professional experience working as full-stack developer.        
        </p>
      </Card>
    </div>
    /* </div> */
  );
};

export default AboutMe;
